import {
  EvaluationCalendarDay,
  EvaluationCalendarSummaryQuery,
} from 'domains/calendars/v3/useEvaluationCalendarSummary';
import { useMemo, useState } from 'react';

type CalendarParams = {
  query: EvaluationCalendarSummaryQuery;
};

export type UseEvaluationCalendar = (params: CalendarParams) => {
  dayIndex: number;
  onChangeDay: (newDayIndex: number) => void;
  evaluationCalendarQuery: EvaluationCalendarSummaryQuery;
} & (
  | {
      isLoading: true;
      currentAvailability: undefined;
      allTimeSlots: undefined;
    }
  | {
      isLoading: false;
      currentAvailability: EvaluationCalendarDay;
      allTimeSlots: EvaluationCalendarDay[];
    }
);

/** Gives the evaluation availability for a given day */
export const useEvaluationCalendar: UseEvaluationCalendar = ({ query }) => {
  const [dayIndex, setDayIndex] = useState<number>(0);

  const { data, isLoading } = query;

  const onChangeDay = (newDayIndex: number) => {
    setDayIndex(newDayIndex);
  };

  const timelineSlots = useMemo(() => {
    if (!data) return;
    return data.summaryData[dayIndex];
  }, [data]);

  if (isLoading || !data) {
    return {
      dayIndex,
      onChangeDay,
      isLoading: true,
      currentAvailability: undefined,
      allTimeSlots: undefined,
      evaluationCalendarQuery: query,
    };
  } else {
    return {
      dayIndex,
      onChangeDay,
      isLoading: false,
      currentAvailability: timelineSlots as EvaluationCalendarDay,
      allTimeSlots: data.summaryData,
      evaluationCalendarQuery: query,
    };
  }
};

export type EvaluationCalendarQuery = ReturnType<typeof useEvaluationCalendar>;
